import StepStatBox from './StepStatBox'

export default function DonateStepStats({ stats, isFirst = false }) {
  const statBoxes = []

  if (stats?.donationsByCurrency && stats.donationsByCurrency.length > 0) {
    stats.donationsByCurrency.forEach((curr, index) => {
      statBoxes.push({
        key: `currency-${curr.currency}`,
        value: `${curr.symbol}${curr.sum.toFixed(2)}`,
        label: `Amount raised (${curr.currency})`,
        isFirst: isFirst && index === 0
      })
    })
  } else if (stats?.donationsSum) {
    const symbol = stats?.donationCurrencySymbol || '£'
    statBoxes.push({
      key: 'currency-legacy',
      value: `${symbol}${parseFloat(stats.donationsSum || 0).toFixed(2)}`,
      label: 'Amount raised',
      isFirst: isFirst
    })
  }

  statBoxes.push({
    key: 'donations-count',
    value: stats?.donationsCount || 0,
    label: 'Number of donations',
    isFirst: isFirst && statBoxes.length === 0
  })

  return (
    <>
      {statBoxes.map(box => (
        <StepStatBox
          key={box.key}
          value={box.value}
          label={box.label}
          isFirst={box.isFirst}
        />
      ))}
    </>
  )
}
